import { Toaster } from 'react-hot-toast';
import { OnlineShopPage } from './OnlineShopPage';
import { useRequireLiffMember } from '../../hooks/useRequireLiffMember';

/**
 * 線上商店／線上訂單應用程式入口
 * 商品來源＝商品管理（與前台 POS 同源），與 /preorder 面交預購分離
 * /online-shopping、/online-order 共用此 App，以 pathname 區分標題
 */
export function OnlineShopApp() {
  const { renderGate } = useRequireLiffMember();

  return (
    <>
      {renderGate(<OnlineShopPage />)}
      <Toaster
        position="top-center"
        toastOptions={{ duration: 3000, style: { fontSize: '1rem' } }}
      />
    </>
  );
}
